import {Stack} from "@mantine/core";
import {useContext} from "react";
import FolderContext from "../../../../../contexts/folder/FolderContext";
import FolderListItem from "./item/FolderListItem";
import Folder from "../../../../../api/folder/Folder";
import CreateButton from "./create-button/CreateButton";

type FoldersListProps = {
    /**
     * Add create button at the end of the list.
     * @author Kacper Faber
     * @since 0.1.9
    */
    withCreateButton?: boolean;
};

function FoldersList(props: FoldersListProps) {
    /**
     * FolderContext
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(FolderContext);

    /**
     * Renders item
     * @author Kacper Faber
     * @since 0.1.8
     */
    const renderItem = (folder: Folder) => {
        return (
            <FolderListItem
                folder={folder}
            />
        );
    };

    /**
     * Add <CreateButton/> if props.withCreateButton - otherwise null.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const renderCreateButton = () => {
        if (!props.withCreateButton) {
            return null;
        }

        return (
            <CreateButton/>
        );
    };

    return (
        <Stack gap="0">
            { ctx.folders?.results?.map(renderItem) }

            { renderCreateButton() }
        </Stack>
    );
}

export default FoldersList;